import { callZigzagFunction } from '../../callZigzagFunction';

// 토스트 메시지 노출
export const tt = (message: string) => {
  callZigzagFunction('tt')({ message });
};
